// update document title before router
export default function updateTitle({ meta, matched }) {
  if (meta?.title) {
    document.title = meta.title
    const description = document.querySelector('meta[name="description"]')
    const keywords = document.querySelector('meta[name="keywords"]')
    if (description && meta.description) {
      description.content = meta.description
    }
    if (keywords && meta.keywords) {
      keywords.content = meta.keywords
    }
  } else {
    const parentTitle = matched[0]?.meta?.title
    if (parentTitle) {
      if (parentTitle !== document.title) {
        document.title = parentTitle
      }
    }
  }
}
